import React from "react";
import { Box } from "@mui/material";
import { SlideBlockView } from "../SlideBlockView";
import type { CanvasSlideBlock } from "../../api/types";
import type { ReportBranding } from "../../utils/branding";

const CANVAS_W = 1280;
const CANVAS_H = 720;

interface CanvasSlideViewProps {
  block: CanvasSlideBlock;
  clientId: string | null;
  branding?: ReportBranding;
  fill?: boolean;
}

export const CanvasSlideView: React.FC<CanvasSlideViewProps> = ({
  block,
  clientId,
  branding,
  fill,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        paddingTop: `${(CANVAS_H / CANVAS_W) * 100}%`,
        bgcolor: "#0B0F14",
        borderRadius: 1,
        overflow: "hidden",
      }}
    >
      <Box sx={{ position: "absolute", inset: 0 }}>
        {block.elements.map((el) => (
          <Box
            key={el.id}
            sx={{
              position: "absolute",
              left: `${(el.x / CANVAS_W) * 100}%`,
              top: `${(el.y / CANVAS_H) * 100}%`,
              width: `${(el.w / CANVAS_W) * 100}%`,
              height: `${(el.h / CANVAS_H) * 100}%`,
              overflow: "hidden",
            }}
          >
            <SlideBlockView
              block={el.block}
              clientId={clientId}
              branding={branding}
              fill={fill}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
